import { QueryConstraint, orderBy, OrderByDirection } from '@angular/fire/firestore'

export class FirestoreSort {
	private constructor(
		readonly property: string,
		readonly direction: OrderByDirection,
	) {}

	static ascending(property: string): FirestoreSort {
		return new FirestoreSort(property, 'asc')
	}

	static descending(property: string): FirestoreSort {
		return new FirestoreSort(property, 'desc')
	}

	toConstraint(): QueryConstraint {
		return orderBy(this.property, this.direction)
	}
}
